__turbopack_context__.v({
  "jobsCard": "JobsComponent-module-scss-module__cEy_lW__jobsCard",
  "jobsCardButtons": "JobsComponent-module-scss-module__cEy_lW__jobsCardButtons",
  "jobsCardHead": "JobsComponent-module-scss-module__cEy_lW__jobsCardHead",
  "jobsComponentContainer": "JobsComponent-module-scss-module__cEy_lW__jobsComponentContainer",
  "jobsComponentItemDescription": "JobsComponent-module-scss-module__cEy_lW__jobsComponentItemDescription",
  "jobsComponentItemTitle": "JobsComponent-module-scss-module__cEy_lW__jobsComponentItemTitle",
  "jobsComponentItems": "JobsComponent-module-scss-module__cEy_lW__jobsComponentItems",
  "jobsComponentText": "JobsComponent-module-scss-module__cEy_lW__jobsComponentText",
});
